import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Input from '../../../../components/Input/Input';
import Button from '../../../../components/Button/Button';
import Select from '../../../../components/Select/Select';
import Modal from '../../../../components/Modal/Modal';
import { useSelector } from 'react-redux';
import { modulePermissions } from '../../../../utils/modulePermissions';
import './NewUser.css';
import eyeOff from '../../../../assets/login/eyeOff.png';
import eyeOn from '../../../../assets/login/eyeOn.png';
//services
import { role } from '../../../../services/role';
import { usersList } from '../../../../services/user';


const NewUser = () => {
  const currentUser = useSelector(state => state.user.userData);
  const location = useLocation();
  const { isEdit, user } = location.state || { isEdit: false, user: null };
  const navigate = useNavigate();
  const [totalUsers, setTotalUsers] = useState(0);

  // Obtener total de usuarios al cargar
  useEffect(() => {
    const fetchTotalUsers = async () => {
      try {
        const response = await usersList.getDataUser({page: 1, items_per_page: 100});
        if (response.status === 'success') {
          setTotalUsers(response.data.total);
        }
      } catch (error) {
        console.error('Error fetching total users:', error);
      }
    };
    fetchTotalUsers();
  }, []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [title, setTitle] = useState({ text: '', highlight: '' });
  const [message, setMessage] = useState('');
  const [errorResponse, setErrorResponse] = useState(false);
  const [roles, setRoles] = useState([{
    id: 0,
    name: ''
  }]);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    status: 'active',
    password: '',
    confirmPassword: '',
    user: '',
    role_id: ''
  });
  const [errors, setErrors] = useState({
    name: '',
    phone: '',
    email: '',
    password: '',
    confirmPassword: '',
    role_id: ''
  });

  useEffect(() => {
    if (isEdit && user) {
      setFormData({
        name: user.name,
        phone: user.phone,
        email: user.email,
        password: '',
        confirmPassword: '',
        user: user.user,
        role_id: user.role
      });
      console.log('Edit user:', user);
    }
    getRoles();
  }, [isEdit, user]);

  const getRoles = async () => {
    try {
      const response = await role.getAllRoles();
      if(response.status === "success") {
        const filteredRoles = response.data.filter(role => role.name !== 'user');
        setRoles(filteredRoles);
        
        if(isEdit && user) {
          const userRole = response.data.find(role => role.name === user.role);
          if (userRole) {
            setFormData(prev => ({
              ...prev,
              role_id: userRole.id
            }));
          }
        }
      }
    } catch (error) {
      console.error('Error fetching roles:', error);
    }
  };

  const handleChange = (e, field) => {
    const value = e.target.value?.value || e.target.value;

    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }

    generateUsername();
  };

  const generateUsername = () => {
    const trimmedName = formData.name?.trim() || '';
    if (trimmedName === '') {
      setFormData(prev => ({
        ...prev,
        user: ''
      }));
      return;
    }
    const nameArray = trimmedName.split(' ').filter(part => part.length > 0);
    if (nameArray.length === 0) {
      setFormData(prev => ({
        ...prev,
        user: ''
      }));
      return;
    }
    let username = '';
    // Obtener la primera letra del primer nombre
    username += nameArray[0].charAt(0).toUpperCase();
    // Obtener la primera letra del primer apellido (si existe)
    if (nameArray.length > 1) {
      username += nameArray[nameArray.length - 1].charAt(0).toUpperCase();
    }
    // Agregar un número basado en el total de usuarios + 1
    console.log('totalUsers:', totalUsers);
    username += (totalUsers + 1).toString().padStart(3, '0');
    setFormData(prev => ({
      ...prev,
      user: username
    }));
  }

  const validateForm = () => {
    const newErrors = {};
    let hasErrors = false;

    // Required field validation
    Object.keys(formData).forEach(field => {
      if(field !== 'status') {
          if(isEdit){
            if (!formData[field] && field !== 'password' && field !== 'confirmPassword') {
              newErrors[field] = 'This field is required';
              hasErrors = true;
            }
        }else {
          if (!formData[field]) {
            newErrors[field] = 'This field is required';
            hasErrors = true;
          }
        }
      }
    });

    // Email validation
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
      hasErrors = true;
    }
    if (!formData.email.endsWith('@barterflip.com')) {
      newErrors.email = 'The email must be @barterflip.com';
      hasErrors = true;
    }

    //Name validation
    if (formData.name.trim().length < 2 || formData.name.trim().length > 250) {
      newErrors.name = 'Name must be between 2 and 250 characters';
      hasErrors = true;
    }

    // Phone validation
    if(formData.phone.trim().length !== 10) {
      newErrors.phone = 'Please enter a valid phone number (10 digits)';
      hasErrors = true;
    }
    if (formData.phone && !/^\+?[\d\s-]+$/.test(formData.phone)) {
      newErrors.phone = 'Please enter a valid phone number';
      hasErrors = true;
    }

    // Password validation
    if (formData.password && (formData.password.length < 8 || formData.password.length > 16)) {
      newErrors.password = 'Password should have at least 8 characters and at most 16 characters';
      hasErrors = true;
    }else if (formData.password && !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/.test(formData.password)) {
      newErrors.password = 'Password must contain at least one uppercase letter, one lowercase letter, and one number';
      hasErrors = true;
    }

    // Confirm password validation
    if (formData.confirmPassword && (formData.confirmPassword.length < 8 || formData.confirmPassword.length > 16)) {
      newErrors.confirmPassword = 'Confirm password should have at least 8 characters and at most 16 characters';
      hasErrors = true;
    }else if (formData.confirmPassword && !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/.test(formData.confirmPassword)) {
      newErrors.confirmPassword = 'Confirm password must contain at least one uppercase letter, one lowercase letter, and one number';
      hasErrors = true;
    }

    // Password match validation
    if(isEdit && formData.password && formData.confirmPassword) {
      if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = 'Passwords do not match';
        hasErrors = true;
      }      
    }else if(!isEdit){
      if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = 'Passwords do not match';
        hasErrors = true;
      }
    }

    setErrors(newErrors);
    return !hasErrors;
  };
 
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Add API call here
      if (isEdit) {
        const data = {
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          status: formData.status,
          new_password: formData.password,
          confirmation: formData.password,
          user: formData.user,
          role_id: formData.role_id
        };
        data.id = user.id;
        const matchingRole = roles.find(role => role.name === formData.role_id);
        data.role_id = matchingRole ? matchingRole.id : formData.role_id;
        if(data.new_password === ''){
          delete data.new_password;
          delete data.confirmation;
        }
        if(user.email === data.email) delete data.email;
        if(user.phone === data.phone){
          delete data.phone;
        }
        if(user.user === data.user){
          delete data.user;
        }
        usersList.updateUser(data, user.id)
          .then(response => {
            console.log('User created successfully:', response);
            setTitle({ text: 'User', highlight: 'updated' });
            if(user.id !== currentUser?.id) {
              setMessage('Successfully updated');
            }else{
              setMessage('When changing the role of the logged-in user, they must log in again to apply the changes.');
            }
            setIsModalOpen(true);
          })
          .catch(error => {
            console.error('Error creating user:', error);
            setTitle({ text: 'Error updating ', highlight: 'user' });
            setMessage(error.response.data.message);
            setIsModalOpen(true);
            setErrorResponse(true);
          });
      } else {
        usersList.createUser(formData)
          .then(response => {
            console.log('User created successfully:', response);
            setTitle({ text: 'User', highlight: 'created' });
            setMessage('User created successfully');
            setIsModalOpen(true);
          })
          .catch(error => {
            console.error('Error creating user:', error);
            setTitle({ text: 'Error registering ', highlight: 'user' });
            setMessage(error.response.data.message);
            setIsModalOpen(true);
            setErrorResponse(true);

          });
      }
    }else{
      console.log('Form is invalid, not submitting');
      console.log('Errors:', errors);
    }
  };

  const handleCancel = () => {
    const roleSelected = roles.find(role => role.id === parseInt(formData.role_id, 10));
    if(errorResponse){
      setErrorResponse(false);
      setIsModalOpen(false);
    }else if(roleSelected && isEdit && user.id === currentUser?.id) {
      modulePermissions.clearPermissions();
      navigate('/');
    }else{
      navigate('/users');
    }
  };

  return (
    <div className="new-user-page">
      <div className="new-user-container">
        <div className="title-container">
          <h5 className="page-title">
            <span className="highlight">{isEdit ? 'Edit' : 'Insert'}</span> the following data
          </h5>
        </div>
        <form onSubmit={handleSubmit} noValidate>
          <div className="form-row">
            <div className="form-group">
              <label>Complete name*</label>
              <Input
                type="text"
                placeholder="Enter your name"
                value={formData.name}
                onChange={(e) => handleChange(e, 'name')}
                error={errors.name}
                required
                size="small"
              />
            </div>
            <div className="form-group">
              <label>Role*</label>
              <Select
                options={roles.map(role => ({
                  label: role.name,
                  value: role.id
                }))}
                value={formData.role_id}
                onChange={(e) => handleChange(e, 'role_id')}
                error={errors.role_id}
                required
                placeholder="Select role"
                name="role_id"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>User*</label>
              <Input
                type="text"
                placeholder="Enter your user"
                value={formData.user}
                onChange={(e) => handleChange(e, 'user')}
                error={errors.user}
                required
                size="small"
                disabled={true}
              />
            </div>
            <div className="form-group">
              <label>Phone*</label>
              <Input
                type="tel"
                placeholder="Enter your phone"
                value={formData.phone}
                onChange={(e) => handleChange(e, 'phone')}
                error={errors.phone}
                required
                size="small"
              />
            </div>
            <div className="form-group">
              <label>Email*</label>
              <Input
                type="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={(e) => handleChange(e, 'email')}
                error={errors.email}
                required
                size="small"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Password*</label>
              <Input
                type="password"
                placeholder="Enter your password"
                value={formData.password}
                onChange={(e) => handleChange(e, 'password')}
                error={errors.password}
                required={isEdit ? false : true}
                size="small"
                icon={eyeOff}
                iconAlt={eyeOn}
              />
            </div>
            <div className="form-group">
              <label>Confirm password*</label>
              <Input
                type="password"
                placeholder="Confirm password"
                value={formData.confirmPassword}
                onChange={(e) => handleChange(e, 'confirmPassword')}
                error={errors.confirmPassword}
                required={isEdit ? false : true}
                size="small"
                icon={eyeOff}
                iconAlt={eyeOn}
              />
            </div>
          </div>

          <div className="form-actions">
            <Button
              type="button"
              variant="warning"
              onClick={() => navigate('/users')}
              borderRadius={20}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              borderRadius={20}
            >
              {isEdit ? 'Update' : 'Create'}
            </Button>
          </div>
        </form>
        <Modal 
          isOpen={isModalOpen}
          error={errorResponse}
          onClose={() => setIsModalOpen(false)}
          title={title}
          message={message}
          onConfirm={handleCancel}
        />
      </div>
    </div>
  );
};

export default NewUser;